import axiosConfig from "./axiosConfig";
import { Lead } from "./getLeads";

const getLead = async (
  authToken: string,
  leadId: string
): Promise<{ lead: Lead }> => {
  const { data } = await axiosConfig.get(`/leads/${leadId}`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getLead;
